<div class="flex flex-col gap-3 w-full animate-fade-in p-4">
  <app-header
    title="Removed Endpoints"
    searchPlaceholder="Search removed endpoints..."
    [showFilter]="false"
    [showNew]="false"
    (onSearch)="handleSearch($event)"
  ></app-header>

  <div *ngIf="loading" class="flex justify-center py-10 text-gray-500">
    <i class="pi pi-spin pi-spinner text-2xl"></i>
  </div>

  <div
    *ngIf="!loading && endpoints.length === 0"
    class="flex flex-col items-center justify-center py-12 text-gray-400 gap-2"
  >
    <i class="pi pi-check-circle text-3xl"></i>
    <span>No removed endpoints.</span>
  </div>

  <div class="flex flex-col gap-3" *ngIf="!loading && endpoints.length > 0">
    <div
      *ngFor="let endpoint of endpoints"
      class="border border-gray-200 rounded-lg p-4 bg-white shadow-sm flex flex-col gap-3"
    >
      <!-- Cabeçalho do endpoint -->
      <div class="flex items-center justify-between gap-3 flex-wrap">
        <div class="flex items-center gap-2 min-w-0">
          <span
            class="px-2 py-0.5 rounded text-xs font-semibold"
            [ngClass]="methodClass(endpoint.httpMethod)"
            >{{ endpoint.httpMethod }}</span
          >
          <span class="font-mono text-sm text-gray-700 truncate">{{ endpoint.routePath }}</span>
        </div>
        <span class="text-xs text-gray-400">{{ endpoint.permissionKey }}</span>
      </div>

      <div class="text-sm text-gray-600" *ngIf="endpoint.displayName">
        {{ endpoint.displayName }}
      </div>

      <!-- Alerta de exclusão -->
      <div
        class="border rounded-md px-3 py-2 text-sm flex items-center gap-2"
        [ngClass]="deletionSeverityClass(endpoint)"
      >
        <i class="pi pi-clock"></i>
        <span>{{ deletionMessage(endpoint) }}</span>
      </div>

      <!-- Associações -->
      <div
        *ngIf="hasAssociations(endpoint); else noAssociations"
        class="flex flex-col gap-3 pt-1"
      >
        <!-- Grupos -->
        <div *ngIf="endpoint.groups?.length" class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase">Permission Groups</span>
          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let group of endpoint.groups"
              class="px-2 py-1 rounded bg-gray-100 text-gray-700 text-xs"
            >
              {{ group.name }}
              <span class="text-gray-400">· {{ group.tenantName }}</span>
            </span>
          </div>
        </div>

        <!-- Usuários -->
        <div *ngIf="endpoint.users?.length" class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase">Users</span>
          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let user of endpoint.users"
              class="px-2 py-1 rounded bg-gray-100 text-gray-700 text-xs"
            >
              {{ user.displayName || user.userName }}
              <span class="text-gray-400" *ngIf="user.email">· {{ user.email }}</span>
            </span>
          </div>
        </div>

        <!-- Tenants -->
        <div *ngIf="endpoint.tenants?.length" class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase">Tenants</span>
          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let tenant of endpoint.tenants"
              class="px-2 py-1 rounded bg-gray-100 text-gray-700 text-xs"
            >
              {{ tenant.name }}
            </span>
          </div>
        </div>
      </div>

      <ng-template #noAssociations>
        <div class="text-xs text-gray-400 italic pt-1">No associations.</div>
      </ng-template>
    </div>
  </div>
</div>
